import { render, staticRenderFns } from "./EditionHistory.vue?vue&type=template&id=e3f5940a&scoped=true"
import script from "./EditionHistory.vue?vue&type=script&lang=js"
export * from "./EditionHistory.vue?vue&type=script&lang=js"
import style0 from "./EditionHistory.vue?vue&type=style&index=0&id=e3f5940a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f5940a",
  null
  
)

export default component.exports